<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('hourlysphReport') }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getHourlySPHReportsReportsSelectedCinema ? 'shift-up':''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>

              <b-dropdown
                :text="getHourlySPHReportsReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="onHourlySPHReportsReportDropDownHandler({ event: $event, name:'isCinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <!-- <custommultiselect
              :options="getCinemasList"
              :selectLabel="''"
              placeholder="Cinemas"
              label="cine_name"
              isSingleId="cine_id"
              :multiple="false"
              track-by="cine_id"
            ></custommultiselect>-->
          </div>

          <div class="col-md-12 mb-4">
            <div class="row d-flex justify-content-center align-items-center">
              <div class="col-md-3 col-lg-3 col-xl-3">
                <div class="input-material">
                  <div class="add-datepicker">
                    <!-- <datetime
                      @input="onHourlySPHReportDateHandler({ event: $event, name: 'fromDate' })"
                      type="date"
                      class="theme-custom-date-time"
                      format="yyyy-MM-dd"
                    ></datetime>-->
                    <button
                      class="btn-clearDate"
                      v-if="getHourlySPHReportFromDate"
                      v-on:click="onHourlySPHReportDateHandler({ event: null, name: 'fromDate' })"
                    >✖</button>
                    <Datepicker :monday-first="true"
                      @selected="onHourlySPHReportDateHandler({ event: $event, name: 'fromDate' })"
                      ref="programaticOpen"
                      :value="getHourlySPHReportFromDate"
                      v-validate="'required'"
                    ></Datepicker>
                    <label :class="getHourlySPHReportFromDate ? 'active': ''">{{ $t("Date") }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-2">Time span from</div>
              <div class="col-md-2 px-0">
                <div class="input-material">
                  <div class="add-datepicker">
                    <datetime
                      type="time"
                      class="theme-custom-date-time"
                      format="hh:mm:ss a"
                      @input="onHourlySPHReportDateHandler({ event: $event, name: 'startTime' })"
                      use12-hour
                    ></datetime>
                  </div>
                </div>
              </div>
              <div class="col-md-1 text-center">to</div>
              <div class="col-md-2 px-0">
                <div class="input-material">
                  <div class="add-datepicker">
                    <datetime
                      type="time"
                      class="theme-custom-date-time"
                      format="hh:mm:ss a"
                      @input="onHourlySPHReportDateHandler({ event: $event, name: 'endTime' })"
                      use12-hour
                    ></datetime>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <button class="btn-blue-lg w-100">{{ $tc('Get Report') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1" style="word-break: break-all;">
          <thead class="bg-lightgrey">
            <tr>
              <th>Items</th>
              <th>Unit</th>
              <th>Value</th>
            </tr>
            <tr>
              <th class="p-0"></th>
              <th class="p-0">
                <table class="w-100">
                  <tr>
                    <th>Qty Sold</th>
                    <th>Net Price</th>
                    <th>Std Profit</th>
                    <th>Std Profit %</th>
                  </tr>
                </table>
              </th>
              <th class="p-0">
                <table class="w-100">
                  <tr>
                    <th>Net Sales</th>
                    <th>Sales Price</th>
                    <th>Net Profit %</th>
                    <th>Profit Mix %</th>
                  </tr>
                </table>
              </th>
            </tr>
          </thead>
          <tbody class="sph-report">
            <tr>
              <td class="text-left p-0">
                <table class="w-100">
                  <tr style="border-bottom: 1px solid;">
                    <th>F&B</th>
                  </tr>
                  <tr>
                    <th>Chips</th>
                  </tr>
                  <tr>
                    <td>Crispy Peanuts</td>
                  </tr>
                  <tr>
                    <td>NACHOS SUPREME</td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr style="borderr-bottom: 1px solid #000000;">
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-1</th>
                    <th>120.00</th>
                    <th>104.82</th>
                    <th>87.35</th>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-120.00</th>
                    <th>-0.01</th>
                    <th>91.25</th>
                    <th>0.01</th>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class>
              <td class="text-left p-0">
                <table class="w-100">
                  <tr>
                    <th>CHOCOLATE</th>
                  </tr>
                  <tr>
                    <td>Nature valley bar</td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-1</th>
                    <th>120.00</th>
                    <th>104.82</th>
                    <th>87.35</th>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-120.00</th>
                    <th>-0.01</th>
                    <th>91.25</th>
                    <th>0.01</th>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class>
              <td class="text-left p-0">
                <table class="w-100">
                  <tr>
                    <th>COLD BEVERAGES</th>
                  </tr>
                  <tr>
                    <td>AMERICANA</td>
                  </tr>
                  <tr>
                    <td>EXPRESSO</td>
                  </tr>
                  <tr>
                    <td>MOUSSY DRINK</td>
                  </tr>
                  <tr>
                    <td>RAUCH JUICE</td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr>
                    <td>-1</td>
                    <td>120.00</td>
                    <td>104.82</td>
                    <td>87.35</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-1</th>
                    <th>120.00</th>
                    <th>104.82</th>
                    <th>87.35</th>
                  </tr>
                </table>
              </td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr>
                    <td>-120.00</td>
                    <td>-0.01</td>
                    <td>91.25</td>
                    <td>0.01</td>
                  </tr>
                  <tr style="border-top: 1px solid #000000;">
                    <th>-120.00</th>
                    <th>-0.01</th>
                    <th>91.25</th>
                    <th>0.01</th>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <th class="p-0 text-left">Grand Total :</th>
              <th class="p-0">
                <table class="w-100">
                  <tr>
                    <th>6,282</th>
                    <th>7.5</th>
                    <th>3.59</th>
                    <th>46.87</th>
                  </tr>
                </table>
              </th>
              <th class="p-0">
                <table class="w-100">
                  <tr>
                    <th>70,779.35</th>
                    <th>100.00</th>
                    <th>55,266.97</th>
                    <th>100.00</th>
                  </tr>
                </table>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY FROM MASTER STORE
      "getCinemasList",
      "getHourlySPHReportsReportsSelectedCinema",
      // HOURLY SPH REPORT STORE
      "getHourlySPHReportFromDate"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.fetchCinemasList({ cinemaId });
  },
  mounted() {},
  methods: {
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "onHourlySPHReportDateHandler",
      "onHourlySPHReportsReportDropDownHandler"
    ])
  },
  beforeDestroy: async function() {
    // await this.$store.dispatch("globalRemoveFile", {
    //   fileName: this.getDistributorExcelFileName
    // });
    // await this.$store.dispatch("globalRemoveFile", {
    //   fileName: this.getDistributorPDFFileName
    // });
    // await this.onResetDistributorStoreState();
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/hourlySphReport.vue